import { BaseOptionType, DefaultOptionType } from '@rc-component/select/lib/Select';
import React, { CSSProperties } from 'react';
import { RefSelectProps, SelectProps, SelectValue } from 'antd/lib/select';
import { CustomTagProps } from '@rc-component/select/lib/BaseSelect';

export const fieldNamesIdName = {
	label: 'name',
	value: 'id',
};
export const fieldNamesTextValue = {
	label: 'text',
	value: 'value',
};
export const fieldNamesTitleValue = {
	label: 'title',
	value: 'value',
};
export type IdObject = { id: string };
export type AntSelectValue = SelectValue;
export type AntSelectRefProps = RefSelectProps;
export type AntDefaultOptionType = DefaultOptionType;
export type OptionExtra = {
	editable?: boolean;
	removable?: boolean;
	tooltip?: string;
	nonRemovableMessage?: string;
	className?: string;
	style?: CSSProperties;
};

export interface AntSelectPropsGeneric<
	VT extends AntSelectValue,
	OptionType extends BaseOptionType = DefaultOptionType,
> extends SelectProps<VT, OptionType> {
	//styles?: SelectStyles;
	sortValues?: boolean;
	sortOptions?: boolean;

	errors?: string[];
	invalid?: boolean;
	editable?: boolean;
	reorderable?: boolean;
	wrapper?: (children: React.ReactNode) => React.ReactNode;
	onBlur?: () => void;
	componentRef?: React.Ref<AntSelectRefProps>;
	closeOnMouseLeave?: boolean;
	onLabelEdit?: (value: string, label: string) => void;
	triggerChangeOnClose?: boolean;
	width?: number;
	layout?: 'default' | 'one-line';

	getOptionExtra?: (item: OptionType) => OptionExtra;
}

export type AntSelectPropsObject<
	VT extends AntSelectValue,
	VTObj extends IdObject = { id: string },
	OptionType extends BaseOptionType = DefaultOptionType,
> = Omit<AntSelectPropsGeneric<VT, OptionType>, 'value' | 'onChange' | 'mode' | 'wrapper'> & {
	valueAsObject: true;
	value?: VTObj[];
	mode: 'multiple';
	onChange?: (value: VTObj[], option: OptionType | OptionType[]) => void;
	objectFields?: (keyof VTObj)[];
};
export type AntSelectPropsPlain<
	VT extends AntSelectValue,
	OptionType extends BaseOptionType = DefaultOptionType,
> = Omit<AntSelectPropsGeneric<VT, OptionType>, 'value' | 'onChange' | 'mode' | 'wrapper'> &
	(AntSelectPropsGeneric<VT, OptionType> & {
		valueAsObject?: false | null | undefined;
	});
export type AntSelectProps<
	VT extends AntSelectValue,
	VTObj extends IdObject = { id: string },
	OptionType extends BaseOptionType = DefaultOptionType,
> = AntSelectPropsObject<VT, VTObj, OptionType> | AntSelectPropsPlain<VT, OptionType>;
export type AntSelectEditableTagProps<VT extends AntSelectValue> = CustomTagProps & {
	value: VT;
	label: React.ReactNode;
	editable?: boolean;
	removable?: boolean;
	nonRemovableMessage?: string;
	tooltip?: string;
	onLabelEdit?: (value: VT, newLabel: string) => void;
	extra: OptionExtra | undefined;
};
export type AntSelectEditableTagOptionsEntry<VT extends AntSelectValue> = Pick<
	AntSelectEditableTagProps<VT>,
	'value' | 'label' | 'editable' | 'removable' | 'tooltip'
>;
export type AntSelectOption = DefaultOptionType;
